import Vue from 'vue'
import VueRouter from 'vue-router'
import Login from '../views/Login.vue'
import RegistrarMesa from '../views/RegistrarMesa.vue'
import Infraestructura from '../views/Infraestructura.vue'

import Especialidades from '../views/Especialidades.vue'
import Servicios from '../views/Servicios.vue'
import Activation from '../views/Activation.vue'
import Register from '../views/Register.vue'
import Recovery from '../views/Recovery.vue'
import Perfil from '../views/Perfil.vue'
import Horarios from '../views/Horarios.vue'
import ResetUser from '../views/ResetUser.vue'
import Imagenes from '../views/Imagenes.vue'
import GoogleMap from '../views/GoogleMap'
import Reservas from '../views/Reservas'
import ReservaManual from '../views/ReservaManual'
import VerReservaManual from '../views/VerReservaManual'
import VerReserva from '../views/VerReserva'
import VerReservaConfirmacion from '../views/VerReservaConfirmacion'
import VisualizarReserva from '../views/VisualizarReserva'
import ImagenesMenu from '../views/ImagenesMenu.vue'
import Tienda from '../views/Tienda.vue'
import Menu from '../views/Menu.vue'
import Contacto from '../views/Contacto.vue'
import DetalleCompra from '../views/DetalleCompra.vue'
import MisCompras from '../views/MisCompras.vue'
import MiStock from '../views/MiStock.vue'
import MiPerfil from '../views/MiPerfil.vue'
import Inicio from '../views/Inicio.vue'
import TerminosCondiciones from '../views/TerminosCondiciones.vue'
import Espera from '../views/Espera.vue'
import EliminarCuenta from '../views/EliminarCuenta.vue'
import ReporteListaEspera from "../views/ReporteListaEspera.vue"

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'login',
    component: Login
  },
  {
    path: '/registrarMesa',
    name: 'RegistrarMesa',
    component: RegistrarMesa
  },
  {
    path: '/activation',
    name: 'Activation',
    component: Activation
  },
  {
    path: '/register',
    name: 'Register',
    component: Register
  },
  {
    path: '/recovery',
    name: 'Recovery',
    component: Recovery
  }
  ,
  {
    path: '/perfil',
    name: 'Perfil',
    component: Perfil
  }
  ,
  {
    path: '/infraestructura',
    name: 'Infraestructura',
    component: Infraestructura
  }
  ,
  {
    path: '/especialidades',
    name: 'Especialidades',
    component: Especialidades
  }
  ,
  {
    path: '/servicios',
    name: 'Servicios',
    component: Servicios
  },
  {
    path: '/horarios',
    name: 'Horarios',
    component: Horarios
  },
  {
    path: '/resetUser',
    name: 'ResetUser',
    component: ResetUser
  },
  {
    path: '/imagenes',
    name: 'Imagenes',
    component: Imagenes
  },
  {
    path: '/ImagenesMenu',
    name: 'ImagenesMenu',
    component: ImagenesMenu
  },
  {
    path: '/map',
    name: 'map',
    component: GoogleMap
  },
  {
    path: '/reservas',
    name: 'Reservas',
    component: Reservas
  },
  {
    path: '/reservaManual',
    name: 'ReservaManual',
    component: ReservaManual
  },
  {
    path: '/verReservaManual',
    name: 'VerReservaManual',
    component: VerReservaManual
  },
  {
    path: '/verReserva',
    name: 'VerReserva',
    component: VerReserva
  },
  {
    path: '/visualizarReserva',
    name: 'VisualizarReserva',
    component: VisualizarReserva
  },
  {
    path: '/verReservaConfirmacion',
    name: 'VerReservaConfirmacion',
    component: VerReservaConfirmacion
  }
  ,
  {
    path: '/tienda',
    name: 'tienda',
    component: Tienda
  },
  {
    path: '/menu/:id',
    name: 'menu',
    component: Menu
  },
  {
    path: '/contacto',
    name: 'contacto',
    component: Contacto
  }
  ,
  {
    path: '/detalle-compra/:id',
    name: 'detalleCompra',
    component: DetalleCompra
  },
  {
    path: '/misCompras',
    name: 'misCompras',
    component: MisCompras
  },
  {
    path: '/miStock',
    name: 'miStock',
    component: MiStock
  },
  {
    path: '/miPerfil',
    name: 'miPerfil',
    component: MiPerfil
  },
  {
    path: '/inicio',
    name: 'inicio',
    component: Inicio
  },
  {
    path: '/terminos-condiciones',
    name: 'terminos-condiciones',
    component: TerminosCondiciones
  },
  {
    path: '/espera',
    name: 'espera',
    component: Espera
  },
  {
    path: '/eliminar-cuenta',
    name: 'eliminar-cuenta',
    component: EliminarCuenta
  },
  {
    path: "/Reporte-lista-espera",
    name: "ReporteListaEspera",
    component: ReporteListaEspera,
  },
  
  
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

export default router
